export const pubSubKeyMap = {
  THEME_PACK_CHAT_CONTEXT_CHANGED: "theme_pack_chat_context_changed",
  LOGIN_SUCCESS: "login_success",
  LOGIN_MODAL_CLOSED: "login_modal_closed",
  SHOW_INVITE_CODE_MODAL: "show_invite_code_modal",
  USER_AGENT_PREFERENCE: "user_agent_preference",
  BIND_TWITTER_SUCCESS: "bind_twitter_success",
  BIND_TWITTER_ERROR: "bind_twitter_error",
  APPEND_CHAT_MESSAGE: "append_chat_message",
  MEMBER_PLAN_INFO: "member_plan_info",
  MEMBER_PAYMENT_ERROR: "member_payment_error",
  PRICE_HEADER_DATA: "header_data",
  CHAT_360: "CHAT_360",
  MENU_SEARCH_MODAL_OPEN: "MENU_SEARCH_MODAL_OPEN",
  MENU_SEARCH_MODAL_CLOSED: "MENU_SEARCH_MODAL_CLOSED",
  COLLECT_CHANGE: "COLLECT_CHANGE",
  CLOSE_SEARCH_MODAL: "CLOSE_SEARCH_MODAL",
  CHAT_DRAWER_STATE_CHANGE: "chat_drawer_state_change",
  /**
   * PC /chat Tab：pending entry 已写入 sessionStorage。
   * ChatTabContent 订阅后递增 pendingEntrySignal，触发 init 消费（同路由不 remount 时必需）。
   */
  CHAT_TAB_PENDING_ENTRY: "chat_tab_pending_entry",
  PORTFOLIO_CHART_SHOW: "portfolio_chart_show",
  // 新增：设置 CopilotSender 的聊天引用内容
  COPILOT_SENDER_SET_CHAT_REF_CONTENT: "copilot_sender_set_chat_ref_content",
  COPILOT_SENDER_CLOSE_CHAT: "copilot_sender_close_chat",
  CHAT_INPUT_FOCUS_CHANGE: "chat_input_focus_change",
  // ChatTabPage/ChatContent：打开 ChatHistory 弹窗（移动端）
  CHAT_OPEN_HISTORY_MODAL: "chat_open_history_modal",
  // Credits相关事件
  TASK_COMPLETED_CREDITS: "task_completed_credits", // 任务完成（奖励为credits）
  TASK_COMPLETED_AURA: "task_completed_aura", // 任务完成（奖励为aura）
  MEMBER_PURCHASE_SUCCESS: "member_purchase_success", // 购买会员成功
  AI_ANSWER_COMPLETED: "ai_answer_completed", // AI回答完毕
  USER_VIEW_DAILY_SUMMARY: "user_view_daily_summary", // 用户查看每日概览
  // 麦克风权限被拒绝时打开语音引导弹窗
  OPEN_VOICE_PERMISSION_MODAL: "open_voice_permission_modal",
  // App 内评分/建议弹窗 - 由业务侧触发打开
  // renew弹窗
  OPEN_RENEW_MODAL: "open_renew_modal",
  // alphapick 页面刷新
  ALPHA_PICK_PAGE_REFRESH: "alpha_pick_page_refresh",
  TRACKER_READ_WATERMARK_UPDATED: "tracker_read_watermark_updated",
};
